import React, { Component } from 'react';
import { connect } from 'react-redux';
import { trackMixpanelPageView } from 'helpers/post';
import TrackingService from 'services/TrackingService';
import { Button } from 'reactstrap';
import './OrganizationType.scss';
import { get } from 'lodash';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';

export const ORGANIZATION_TYPE_OPTIONS = [
  {
    title: 'School / College / University',
    value: 'school',
  },
  {
    title: 'Sport Org',
    value: 'sports',
  },
  {
    title: 'Hospital / Clinic',
    value: 'medical',
  },
  {
    title: 'Industrial / Occupational',
    value: 'industrial',
  },
  {
    title: 'Sports Facility',
    value: 'facility',
  },
  {
    title: 'Performing Arts',
    value: 'performing_arts',
  },
];

class OrganizationType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOrgType: null,
      selectedOrgTitle: null,
    };
    this.trackingService = new TrackingService();
  }

  componentDidMount() {
    trackMixpanelPageView('/create-account/organization-type');

    // Query params are automatically captured by withQueryParamCapture HOC
    // Check if orgType exists in localStorage (set by hook or previous selection)
    const storedOrgType = localStorage.getItem('registrationOrgType');

    if (storedOrgType) {
      const orgOption = ORGANIZATION_TYPE_OPTIONS.find(option => option.value === storedOrgType);
      if (orgOption) {
        // Update state to show selection in UI
        this.setState({
          selectedOrgType: storedOrgType,
          selectedOrgTitle: orgOption.title,
        });

        // If orgType came from URL parameter, auto-route to sign-up
        const searchParams = get(this.props, 'location.search', '');
        if (searchParams) {
          const params = new URLSearchParams(searchParams);
          const urlOrgType = params.get('orgType');
          if (urlOrgType === storedOrgType) {
            // Auto-route to sign-up since orgType was in URL
            this.props.history.push('/sign-up');
          }
        }
      }
    }
  }

  onSelect = (orgType, title) => e => {
    e.preventDefault();
    e.currentTarget.blur();
    this.setState({
      selectedOrgType: orgType,
      selectedOrgTitle: title,
    });
    trackMixpanelPageView('/organization_type_selected', {
      organization_type: orgType,
      organization_title: title,
      page: '/create-account/organization-type',
    });
  };

  onContinue = () => {
    const { selectedOrgType } = this.state;
    localStorage.setItem('registrationOrgType', selectedOrgType);
    if (selectedOrgType) {
      this.props.history.push('/sign-up');
    }
  };

  onBack = () => {
    this.props.history.push('/create-account/role');
  };

  renderChoiceCard = ({ title, value, isSelected }) => (
    <div className="choice" key={title}>
      <button
        className={`type-button gotham-bold-font ${isSelected ? 'selected' : ''}`}
        onClick={this.onSelect(value, title)}
      >
        {title}
      </button>
    </div>
  );

  render() {
    const { selectedOrgType } = this.state;
    const buttonDisabled = !selectedOrgType;

    return (
      <div className="eventType organization-type">
        <header>
          <div className="screen-title">Describe your organization</div>
        </header>
        <main>
          <div className="organization-options">
            {ORGANIZATION_TYPE_OPTIONS.map(({ title, value }) =>
              this.renderChoiceCard({
                title,
                value,
                isSelected: selectedOrgType === value,
              })
            )}
          </div>
          <div className="navigation-buttons">
            <button className="back-link" onClick={this.onBack}>
              BACK
            </button>
            <Button
              onClick={this.onContinue}
              className="continue-button"
              color="success"
              disabled={buttonDisabled}
            >
              <div>Continue</div>
            </Button>
          </div>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.session.authenticated,
  user: state.session.currentUser,
});

// Wrap with HOC to automatically capture query parameters
export default withQueryParamCapture(connect(mapStateToProps)(OrganizationType));
